<template>
<div class="m-module">
    <div class="section">
        <div class="page-title" >
            <div class="info">
                <h1 class="title">{{ $t("lang.Identification") }}</h1>
                <!-- <div class="status status-success"><van-icon name="checked" /> Verified</div> -->
            </div>
            <!-- <van-icon name="arrow" /> -->
        </div>
        <div class="mod">
            <!-- <div class="hd">
                <h3 class="title">Account Limits</h3>
            </div> -->
            <div class="bd">
                <div class="unauthorized">
                    <div class="icon"></div>
                    <div class="text" v-if="userInfo && userInfo.auditState ==1 ">{{ $t("lang.authorized") }}</div>
                    <div class="text" v-else>{{ $t("lang.Unauthorized") }}</div>
                    <div class="action" v-if="!userInfo || userInfo.auditState ==2 " >
                        <el-button type="primary" round size="small" @click="authentication">{{ $t("lang.authentication") }}</el-button>
                    </div>
                </div>
                 <!-- <van-cell-group>
                    <van-cell title="Flat Deposit & Widthdrawal Limits" value="50K USD Daily"></van-cell>
                    <van-cell title="Crypto Deposit Limit" value="Unlimited"></van-cell>
                    <van-cell title="Crypto Widthdrawal Limit" value="8M BUSD Daily"></van-cell>
                    <van-cell title="P2P Transaction Limits" value="Unlimited"></van-cell>
                </van-cell-group> -->
            </div>
        </div>
        <div class="mod" v-if="userInfo">
            <div class="hd">
                <h3 class="title">{{ $t("lang.PersonalInformation") }}</h3>
            </div>
            <div class="bd">
                 <van-cell-group>
                    <van-cell :title="$t('lang.LegalName')" :value="userInfo.uname"></van-cell>
                    <van-cell :title="$t('lang.DateOfBirth')" :value="userInfo.birthday"></van-cell>
                    <van-cell :title="$t('lang.ideAddress')" :value="userInfo.address"></van-cell>
                    <van-cell :title="$t('lang.IdentificationNumber')" :value="userInfo.idNo"></van-cell>
                    <van-cell :title="$t('lang.EmailAddress')" >
                        <template #title>
                            <div class="cell-title">
                                <div class="cell-icon">
                                    <img class="img" :src="api+userInfo.frontImg"  />
                                    <div class="text">{{ $t("lang.frontIDCard") }}</div>
                                </div>
                                <div class="cell-info">
                                    <img class="img" :src="api + userInfo.backImg" />
                                    <div class="text">{{ $t("lang.ReverseIDCard") }}</div>
                                </div>
                            </div>
                        </template>
                    
                    </van-cell>
                </van-cell-group>
            </div>
        </div>
    </div>
    <van-popup v-model="verifyPopup" @close="closePup"  :close-on-click-overlay="false" position="bottom" closeable :style="{ height: '60%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">{{ $t("lang.PersonalInformation") }}</h3>
            </div>
            <van-divider />
            <div class="bd">
                <div class="form-container">
                    <van-form>
                        <van-field v-model="form.uname"  :label="$t('lang.LegalName')" :placeholder="$t('lang.PleaseLegalName')" />
                        <van-field v-model="form.birthday"  :label="$t('lang.DateOfBirth')" readonly clickable @click="showDatePicker" :placeholder="$t('lang.PleaseDateOfBirth')" /> 
                        <van-field v-model="form.address"  :label="$t('lang.ideAddress')" :placeholder="$t('lang.PleaseIdeAddress')" />
                        <van-field v-model="form.idNo"  :label="$t('lang.IdentificationNumber')"  :placeholder="$t('lang.PleaseIdentificationNumber')" />
                        <van-field :label="$t('lang.IdentificationDocuments')" >

                            <template #input>
                                <div>
                                     <van-uploader :after-read="afterReadA" v-model="fileListA" max-count="1" /> 
                                     <div>{{ $t("lang.frontIDCard") }}</div>
                                </div>
                                <div> 
                                    <van-uploader :after-read="afterReadB" v-model="fileListB" max-count="1" />
                                    <div>{{ $t("lang.ReverseIDCard") }}</div>
                                </div>    
                            </template>
                        </van-field>

                    </van-form>
                </div>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block type="primary" @click="submit">{{ $t("lang.submit") }}</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker :min-date="minDate"  :max-date="maxDate" :confirm-button-text="$t('lang.confirmText')"	:cancel-button-text="$t('lang.cancelText')" type="date" @cancel="showPicker = false" @confirm="confirmTimeDate"/>
    </van-popup>
    <van-popup v-model="levelsPopup" position="bottom" closeable>
        <div class="popup-view">
            <div class="hd">
                <h3 class="title">Verification Levels</h3>
            </div>
            <van-divider />
            <div class="bd">
                <el-timeline class="level-list">
                    <el-timeline-item icon="el-icon-check" color="#44ac30">
                        <div class="timeline-item item-success">
                            <div class="item-title">Verified</div>
                            <div class="item-text">Flat Limit of 50K USD Daily</div>
                            <div class="item-description">
                                Verified:
                                <ul class="item-metas">
                                    <li>Personal information</li>
                                    <li>Government-issued ID</li>
                                    <li>Facial recognition</li>
                                </ul>
                            </div>
                        </div>
                    </el-timeline-item>
                    <el-timeline-item>
                        <div class="timeline-item">
                            <div class="item-title">Verified Plus</div>
                            <div class="item-text">Flat Limit of 2M USD Daily</div>
                            <div class="item-description">
                                Required:
                                <ul class="item-metas">
                                    <li>Rroof of address</li>
                                </ul>
                            </div>
                        </div>
                    </el-timeline-item>
                    <el-timeline-item>
                        <div class="timeline-item">
                            <div class="item-title">Verified Plus</div>
                            <div class="item-text">Unlimited Flat Transactions</div>
                            <div class="item-description">
                                Required:
                                <ul class="item-metas">
                                    <li>Rroof of address</li>
                                    <li>Enhanced due dilligence</li>
                                </ul>
                            </div>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </div>
    </van-popup>
</div>
</template>
<script>
import Header from "@/components/mobile/header";
import lineChart from "@/views/account/modules/lineChart.vue";
import { Dialog } from 'vant';
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
export default {
    name:'identification-m',
    components: {
        Header,
        lineChart,
    },
    data(){
        return {
            verifyPopup:false,
            showPicker:false,
            levelsPopup:false,
            api:BASE_GLOB_API,
            form:{
                uname:'',
                birthday:'',
                address:'',
                idNo:'',
                idType:1,
                backImg:'',
                frontImg:'',
                id:''
            },
            url:{
                detail:BASE_GLOB_API+'/realName/detail',
                idCardPhoto:BASE_GLOB_API+'/realName/idCardPhoto',
                uploadIdCardImg:BASE_GLOB_API+'/realName/uploadIdCardImg',
            },
            userInfo:{},
            fileListA:[],
            fileListB:[],
            lang: "",
            minDate: new Date(1960, 0, 1),
            maxDate: new Date(2025, 10, 1),
        }
    },
    created(){
      this.lang = sessionStorage.getItem("Language")
      this.realNameDetail()
    },
    mounted(){
      
    },
    methods:{
        closePup(){
                this.verifyPopup =false;  
                this.form.uname =''
                this.form.birthday = ''
                this.form.address = ''
                this.form.idNo = ''
                this.form.backImg = ''
                this.form.frontImg =''
                this.form.id =''
                this.fileListA =[]
                this. fileListB=[]
        },
        authentication(){
            if(this.userInfo){
                this.form.uname =this.userInfo.uname
                this.form.birthday = this.userInfo.birthday
                this.form.address = this.userInfo.address
                this.form.idNo = this.userInfo.idNo
                this.form.backImg =  this.userInfo.backImg
                this.form.frontImg = this.userInfo.frontImg
                this.form.id = this.userInfo.id
                this.fileListA =[]
                this. fileListB=[]
                this.fileListA.push({
                    url:this.api + this.userInfo.frontImg
                })
                this.fileListB.push({
                    url:this.api + this.userInfo.backImg
                })
            }
        

          this.verifyPopup =true
        },
        submit(){
            if(!this.form.uname){
                this.$message.error(this.$t("lang.PleaseLegalName"));
                return;
            }
            if(!this.form.birthday){
                this.$message.error(this.$t("lang.PleaseDateOfBirth"));
                return;
            }
            if(!this.form.address){
                this.$message.error(this.$t("lang.PleaseIdeAddress"));
                return;
            }
            if(!this.form.idNo){
                this.$message.error(this.$t("lang.PleaseIdentificationNumber"));
                return;
            }
            if(this.fileListA.length <=0){
                this.$message.error(this.$t("lang.frontIDCardText"));
                return;
            }
            if(this.fileListB.length <=0){
                this.$message.error(this.$t("lang.ReverseIDCardText"));
                return;
            }
            axiosPost(this.url.idCardPhoto, this.form).then(res=>{
                if(res.code == 200){
                  this.realNameDetail()
                  this.closePup()
                  this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        confirmTimeDate(date){
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                m = m < 10 ? ('0' + m) : m;
                var d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                console.log("222", y + '-' + m + '-' + d)
             this.form.birthday = y + '-' + m + '-' + d
             this.showPicker =false
        },
        afterReadA(file) {
            console.log("file",file);
        
            let data = new FormData();
            data.append("file", file.file);
            // for (var value of data.values()) {
            //     console.log('1',value);
            //     }
            axiosPost(this.url.uploadIdCardImg, data).then(res=>{
                if(res.code == 200){
                    this.form.frontImg =res.result
                  
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        afterReadB(file) {
            console.log("file",file);
        
            let data = new FormData();
            data.append("file", file.file);
            // for (var value of data.values()) {
            //     console.log('1',value);
            //     }
            axiosPost(this.url.uploadIdCardImg, data).then(res=>{
                if(res.code == 200){
                    this.form.backImg =res.result
                   
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        realNameDetail(){

            axiosGet(this.url.detail).then(res=>{
                if(res.success){
                  this.userInfo = res.result
                //   this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        showDatePicker(){
            this.showPicker = true;
        },
    }
}
</script>
<style lang="less" scoped>
.m-module {
    .section {
        .page-title {
            font-size:18px; font-weight:600; padding:30px 15px; display:flex; justify-content: space-between; align-items: center;
            .status {
                font-size:16px; color:#999;
                &.status-success {
                    color:#44ac30;
                }
            }
        }
        .mod {
            margin-bottom:20px;
            .hd {
                .title {
                    padding:10px 16px; font-size:16px; font-weight:600;
                }
            }
            .cell-title{
                 display: flex;
                 justify-content: space-around;
                .cell-icon{
                    width: 45%;
                    height: 150px;
                    .img{
                        height: 120px; 
                    }
                    .text{
                       text-align: center;
                    }
                    
                }
                .cell-info{
                    width: 45%;
                    height: 150px;
                    .img{
                        height: 120px; 
                    }
                    .text{
                       text-align: center;
                    }
                   
                }
            }
        }
    }
}
.popup-mod {
    height:100%; position:relative; overflow: hidden;
    .hd {
        padding:16px 16px;
        .title {
            font-size:16px; font-weight:700;
        }
    }
    .van-divider {margin:0;}
    .bd {
        position:absolute; top:52px; left:0; right:0; bottom:54px; overflow:auto;
        .form-container {
            ::v-deep .van-field {
                display:block;
                .van-field__label {
                    width:auto;
                }
            }
        }
    
    }
    .ft {
        position:absolute; z-index:1; left:0; bottom:0; right:0; height:54px;
        .form-action {
            padding:5px 16px;
        }
    }
}
.popup-view {
    .hd {
        padding:16px 16px;
        .title {
            font-size:16px; font-weight:700;
        }
    }
    .van-divider {margin:0;}
    .bd {
        padding:0 16px;
    }
    ::v-deep .level-list {
        padding:20px 0 0 15px;
        .el-timeline-item {
            .el-timeline-item__node {
                width:20px; height:20px; left:-5px;
            }
        }
        .timeline-item {
            padding:4px 0 0;
            .item-title {
                color:#333; font-weight:700; font-size:16px;
            }
            .item-text {
                font-weight:600; font-size:14px; color:#666;
            }
            .item-description {
                padding:10px 0 10px; color:#666;
                .item-metas {
                    margin:4px 0 0 20px;
                    &>li {
                        list-style-type: disc;
                    }
                }
            }
            &.item-success {
                .item-title {
                    color:#44ac30;
                }
            }
        }
    }
}
.unauthorized {
    text-align:center; padding:30px; background:#fff;
    .icon {
        background:url('~@/assets/img/status_identification.svg') no-repeat center center/contain; width:64px; height:64px; margin:0 auto 5px;
    }
    .text {font-size:14px; color:#999; padding:0 0 15px;}
}
</style>